import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Loading from '../../components/Loading';
import Colors from '../../styles/colors';

const SubmitButton = (props = {}) => {
  const { label, loading = false, disabled = false, onSignIn } = props;

  const btnContent = loading ? (
    <Loading
      text="Verifying"
      type="circle"
      align="center"
      size={30}
      fontSize={1.6}
      color="#fff"
      fill="#fff"
    />
  ) : (
    label
  );

  return (
    <Button
      id="appSigninBtnTest"
      onClick={onSignIn}
      disabled={disabled}
      className={`btn text-medium text-white xs-width-100 ${loading ? 'disabled' : ''}`}>
      <ButtonText>{btnContent}</ButtonText>
    </Button>
  );
};

const Button = styled.button`
  background-color: ${props => (props.processing ? '#404040' : Colors.mainOrange)};
  margin-top: 10px;
  margin-bottom: 15px;
  width: 111px;
  height: 38px;
  border-radius: 2px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.08);
`;

const ButtonText = styled.div`
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`;
SubmitButton.propTypes = {
  label: PropTypes.string,
  loading: PropTypes.bool,
  onSignIn: PropTypes.func,
};

SubmitButton.defaultProps = {
  label: 'SIGN IN',
  loading: false,
  onSignIn: () => {},
  disabled: false,
};

export default SubmitButton;
